export default "__VITE_ASSET__8GmY5Jy0__"